import useStepFlow from "src/Modules/Flights/hooks/useStepFlow";

export default function WizardHeader() {
  const { currentStepConfig: stepDetails } = useStepFlow();
  return (
    stepDetails?.inPageTitle && (
      <div className="flex w-full items-center gap-2 rounded-sm">
        <div className="flex flex-col text-2xl font-bold gap-0.5">
          <div className="text-lg md:text-2xl">{stepDetails?.inPageTitle}</div>
          <div className="text-xs font-semibold text-font-minimal md:text-sm">{stepDetails?.inPageSubtitle}</div>
        </div>
      </div>
    )
  );
}
